import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[rtI18n]',
  standalone: true,
})
export class RtI18nDirective implements OnInit, OnChanges, OnDestroy {
  /** Optional explicit key: rtI18n="home.title" */
  @Input('rtI18n') key?: string;

  /** Params for placeholders like [[name]] */
  @Input() rtI18nParams: Record<string, any> | null = null;

  private sub?: Subscription;
  private defaultText = '';
  private effectiveKey = '';
  private initialized = false;

  constructor(
    private el: ElementRef<HTMLElement>,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    // Capture whatever was in the template as the default
    this.defaultText = (this.el.nativeElement.innerText || '').trim();

    this.effectiveKey = (this.key || this.defaultText).trim();
    this.initialized = true;

    this.render(this.effectiveKey);

    // Re-render on language changes
    this.sub = this.translate.onLangChange.subscribe(() => {
      this.render(this.effectiveKey);
    });
  }

  ngOnChanges(): void {
    // Re-render when inputs (e.g. rtI18nParams) change after initialization.
    // Before ngOnInit runs, effectiveKey/defaultText aren't set yet, so skip.
    if (this.initialized) {
      // Recompute in case an explicit key was bound and changed
      this.effectiveKey = (this.key || this.defaultText).trim();
      this.render(this.effectiveKey);
    }
  }

  // private render(key: string) {
  //   // Try translation; if missing, ngx-translate will give back the key
  //   const translated = this.translate.instant(key);
  //   const base =
  //     translated && translated !== key ? translated : this.defaultText;

  //   this.el.nativeElement.innerText = this.applyParams(
  //     base,
  //     this.rtI18nParams || {}
  //   );
  // }

  private render(key: string) {
  const params = this.rtI18nParams || {};

  // IMPORTANT: pass params so ICU plural can see {count}
  if (key) {
    const translated = this.translate.instant(key, params);
    const base =
      translated && translated !== key ? translated : this.defaultText;

    this.el.nativeElement.innerText = this.applyParams(
      base,
      params
    );
  }
}


  private applyParams(
    template: string,
    params: Record<string, any>
  ): string {
    if (!params || !template) return template;

    // Replace [[param]] with value
    return template.replace(/\[\[(\w+)\]\]/g, (match, paramName) => {
      if (params[paramName] === undefined || params[paramName] === null) {
        return match; // leave as is if missing
      }
      return String(params[paramName]);
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
